const routers = [
  {
    path: "/",
    auth: false,
    exact: true,
    redirect: "/auth/login",
  },
  {
    component: "AuthLayout",
    path: "/auth",
    auth: false,
    exact: false,
    childrens: [
      {
        component: "LoginPage",
        path: "/login",
        auth: false,
        exact: false,
      },
      {
        component: "ResetPasswordPage",
        path: "/reset-password",
        auth: false,
        exact: false,
      },
      {
        component: "ForgotPasswordPage",
        path: "/forgot-password",
        auth: false,
        exact: false,
      },
    ],
  },
  {
    component: "MainLayout",
    path: "/admin",
    auth: false,
    exact: false,
    childrens: [
      {
        component: "DashboardPage",
        path: "/dashboard",
        auth: false,
        exact: false,
      },
      // STAFFS AND ROLES
      {
        component: "StaffAndRolePage",
        path: "/staffs&roles",
        auth: false,
        exact: true,
      },
      {
        component: "AddStaffPage",
        path: "/staffs&roles/add-staff",
        auth: false,
        exact: false,
      },
      {
        component: "AddRolePage",
        path: "/staffs&roles/add-role",
        auth: false,
        exact: false,
      },
      {
        component: "EditRolePage",
        path: "/staffs&roles/edit-role/:id",
        auth: false,
        exact: false,
      },
      {
        component: "EditStaffPage",
        path: "/staffs&roles/edit-staff/:id",
        auth: false,
        exact: false,
      },
      // INVENTORY
      {
        component: "InventoryListPage",
        path: "/inventory/list",
        auth: false,
        exact: false,
      },
      {
        component: "InventoryDetailPage",
        path: "/inventory/detail/:id",
        auth: false,
        exact: false,
      },
      {
        component: "EditInventoryPage",
        path: "/inventory/edit/:id",
        auth: false,
        exact: false,
      },
      // DONATION
      {
        component: "DonationListPage",
        path: "/donation/list",
        auth: false,
        exact: false,
      },
      {
        component: "DonationDetailPage",
        path: "/donation/detail/:id",
        auth: false,
        exact: false,
      },
      {
        component: "EditDonationPage",
        path: "/donation/edit/:id",
        auth: false,
        exact: false,
      },
      {
        component: "AddDonationPage",
        path: "/donation/add/:id",
        auth: false,
        exact: false,
      },
      {
        component: "SelectCategoryPage",
        path: "/donation/select-category",
        auth: false,
        exact: false,
      },
      // DIRECTORY
      {
        component: "SellerPage",
        path: "/directory/seller",
        auth: false,
        exact: false,
      },
      {
        component: "BuyerPage",
        path: "/directory/buyer",
        auth: false,
        exact: false,
      },
      {
        component: "InfluencerPage",
        path: "/directory/influencer",
        auth: false,
        exact: false,
      },
      // TRANSACTIONS
      {
        component: "TransactionListPage",
        path: "/transactions/list",
        auth: false,
        exact: false,
      },
      // DISPUTED
      {
        component: "DisputedListPage",
        path: "/dispute/list",
        auth: false,
        exact: false,
      },
      {
        component: "ViewDisputePage",
        path: "/dispute/viewdispute/:id",
        auth: false,
        exact: true,
      },
      {
        component: "DisputeHistoryPage",
        path: "/dispute/dispute-history",
        auth: false,
        exact: false,
      },
      // NOTIFICATION
      {
        component: "Notification",
        path: "/not",
        auth: false,
        exact: true,
      },
      // Payments
      {
        component: "PaymentListPage",
        path: "/payments/:id",
        auth: false,
        exact: true,
      },
      {
        component: "ViewPaymentListPage",
        path: "/payments/viewpayments/:id",
        auth: false,
        exact: true,
      },
      {
        component: "AddSellerPage",
        path: "/payments/addSeller",
        auth: false,
        exact: false,
      },
      {
        component: "AddUpiPage",
        path: "/payments/addUpi",
        auth: false,
        exact: false,
      },
      {
        component: "PaymentHistoryPage",
        path: "/payments/payment-history",
        auth: false,
        exact: false,
      },
    ],
  },
];

export default routers;
